/**
 * SessionProgressStatusService
 * Service for managing session progress statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for session progress status CRUD operations
 */
export class SessionProgressStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SessionProgressStatusService.DEFAULT_SERVICE_PATH,
            basePath: SessionProgressStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
SessionProgressStatusService.DEFAULT_SERVICE_PATH = 'ac-courses';
SessionProgressStatusService.BASE_PATH = 'api/session-progress-statuses';
//# sourceMappingURL=SessionProgressStatusService.js.map